module.exports = __webpack_public_path__ + "assets/img/Employment-Innovations-Pillar-Page-Resource.342524db.webp";